/* eslint-disable */


// Programatically generated on Wed Apr 15 2026 20:54:41 GMT+0000
import {fromJS, List, Map, Record, Set} from 'immutable';
import {GenericModel} from 'resources/Generic.model';
import {validate, Empty} from '@albert-io/json-api-framework/models/helpers';
import moment from 'moment';

const ModelConfig = fromJS(
  {
    'endpoint': 'test_triangles_v1',
    'attributes': {
      'a': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'b': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'c': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'name': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'perimeter_2': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'email_sent_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'updated_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'x': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'y': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'z': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'inserted_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'perimeter': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      }
    },
    'relationships': {}
  }
);

const ModelRecord = Record(
  {
    'a': Empty,
    'b': Empty,
    'c': Empty,
    'name': Empty,
    'perimeter_2': Empty,
    'email_sent_at': Empty,
    'updated_at': Empty,
    'x': Empty,
    'y': Empty,
    'z': Empty,
    'inserted_at': Empty,
    'id': Empty,
    'perimeter': Empty,
    'relationshipMeta': Empty,
    'meta': new Map({
    'populated_metadata_fields': Empty
  })
  }
);

const DefaultModel = fromJS(
  {
    'a': 0,
    'b': 0,
    'c': 0,
    'name': '',
    'meta': new Map(),
    'perimeter_2': 0,
    'id': '',
    'email_sent_at': new Date(),
    'updated_at': new Date(),
    'x': 0,
    'y': 0,
    'z': 0,
    'inserted_at': new Date(),
    'perimeter': 0,
    'relationshipMeta': new Map()
  }
);

export class TestTrianglesModelV1 extends GenericModel(ModelRecord, ModelConfig, 'TestTrianglesModelV1') {
  // -- Query Rules --
  /**
   * @returns {boolean}
   */
  static allowsInclude(include) {
    // AllowedIncludes is currently disabled.
    return true; // AllowedIncludes.has(include);
  }

  /**
   * @returns {boolean}
   */
  static allowsFilter(filterField, filterType) {
    return filterType ?
      FilterRules.get(filterField).has(filterType) :
      FilterRules.has(filterField);
  }

  /**
   * @returns {boolean}
   */
  static allowsSort(sort) {
    return sort.split(',').filter((s) => AllowedSorts.has(s)).length > 0;
  }

  /**
   * @returns {Array}
   */
  static getAllowedSorts() {
    return AllowedSorts.keySeq().toJS();
  }

  static getMetaContextQuery(key) {
    if (!MetadataContextRules.hasIn(['optional', key]) && !MetadataContextRules.hasIn(['required', key])) {
      console.error('Rule for meta context key ' + key + ' does not exist');
    }

    return MetadataContextRules.getIn(['optional', key]) || MetadataContextRules.getIn(['required', key]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getRequiredMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values()]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getAllMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values(), ...MetadataContextRules.get('optional').values()]);
  }

  static getDefaultModel() {
    _emptyTestTrianglesModelV1Model = _emptyTestTrianglesModelV1Model ? _emptyTestTrianglesModelV1Model : new TestTrianglesModelV1(DefaultModel);
    return _emptyTestTrianglesModelV1Model;
  }

  static supportsMetaContext() {
    return MetadataContextRules !== null;
  }

  /**
   * @returns {string}
   */
  static getModelName() {
    return 'TestTrianglesModelV1';
  }

  /**
   * @returns {boolean}
   */
  static _isFullSpec() {
    return true;
  }

  constructor() {
    super(...arguments);
    this.__meta = null;
  }

  /**
   * @returns {string}
   */
  getJsonApiType() {
    return 'test_triangles_v1';
  }

  /**
   * @params {string} - An attribute name
   * @params {*} [def] - Optional default value override for the attribute
   */
  getValueForAttribute(attribute, def) {
    let value = this.get(attribute);
    validate(value, attribute);
    if (value === Empty) {
      value = def !== undefined ? def : DefaultModel.get(attribute);
    }
    return value;
  }

  // -- Primary Attributes --
  
  /**
   * @type {integer}
   */
  getA() {
    const value = this.getValueForAttribute('a');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setA(value) {
    return this.setField('a', value);
  }

  /**
   * @type {integer}
   */
  getB() {
    const value = this.getValueForAttribute('b');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setB(value) {
    return this.setField('b', value);
  }

  /**
   * @type {integer}
   */
  getC() {
    const value = this.getValueForAttribute('c');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setC(value) {
    return this.setField('c', value);
  }

  /**
   * @type {datetime}
   */
  getEmailSentAt() {
    const value = this.getValueForAttribute('email_sent_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {binary_id}
   */
  getId() {
    const value = this.getValueForAttribute('id');
    return value;
  }

  setId(value) {
    return this.setField('id', value);
  }

  /**
   * @type {datetime}
   */
  getInsertedAt() {
    const value = this.getValueForAttribute('inserted_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {string}
   */
  getName() {
    const value = this.getValueForAttribute('name');
    return value;
  }

  setName(value) {
    return this.setField('name', value);
  }

  /**
   * @type {integer}
   */
  getPerimeter() {
    const value = this.getValueForAttribute('perimeter');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setPerimeter(value) {
    return this.setField('perimeter', value);
  }

  /**
   * @type {integer}
   */
  getPerimeter2() {
    const value = this.getValueForAttribute('perimeter_2');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setPerimeter2(value) {
    return this.setField('perimeter_2', value);
  }

  /**
   * @type {datetime}
   */
  getUpdatedAt() {
    const value = this.getValueForAttribute('updated_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {integer}
   */
  getX() {
    const value = this.getValueForAttribute('x');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setX(value) {
    return this.setField('x', value);
  }

  /**
   * @type {integer}
   */
  getY() {
    const value = this.getValueForAttribute('y');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setY(value) {
    return this.setField('y', value);
  }

  /**
   * @type {integer}
   */
  getZ() {
    const value = this.getValueForAttribute('z');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setZ(value) {
    return this.setField('z', value);
  }

  // -- Meta Attributes --
  
    /**
     * LEGACY META ACCESSORS
     * @todo These should no longer be used, instead use this.getMeta()[...]
     */
    
      getPopulatedMetadataFields() {
        return this.getMeta().getPopulatedMetadataFields();
      }
    
    getMeta() {
      if (this.__meta) {
        return this.__meta;
      }
      const meta = this.get('meta', Map());
      this.__meta = {
        
          /**
           * @type {string[]}
           */
          getPopulatedMetadataFields() {
            const value = meta.get('populated_metadata_fields');
            validate(value, 'populated_metadata_fields');
            return value;
          },
  
      };
      return this.__meta;
    }
  
  // -- Relationships --
  
}

// -- Empty Model Instance --
let _emptyTestTrianglesModelV1Model = null;

// -- Sort Rules --

const AllowedSorts = fromJS({
  'a': null,
  'b': null,
  'c': null,
  'email_sent_at': null,
  'id': null,
  'inserted_at': null,
  'name': null,
  'perimeter': null,
  'perimeter_2': null,
  'updated_at': null,
  'x': null,
  'y': null,
  'z': null,
});

// -- Include Rules --
// List []

// -- Filter Rules --
const FilterRules = new Map({
  'a': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'b': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'c': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'email_sent_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'inserted_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.populated_metadata_fields': new Set(['null']),
  'name': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'perimeter': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'perimeter_2': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'updated_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'x': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'y': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'z': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
});
    

// -- Metadata Context Rules --
const MetadataContextRules = fromJS({
  optional: {
  },
  required: {
  }
});

// -- Legacy Name Export --
export const TestTriangles = TestTrianglesModelV1;
